<h1 translate>home.FAQ</h1>
<div *ngIf="selectedInfoLabel">
    <pre>{{selectedInfoLabel.text}}</pre>
</div>